import { Injectable } from '@angular/core';
import { BaseTableService } from './base-table.service';
import { ControllerNote } from 'src/app/model/controllerNotes/controllerNote';

@Injectable({
  providedIn: 'root',
})
export class ControllerNoteTableService extends BaseTableService<ControllerNote> {
  constructor() {
    super();
  }
}
